import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import CreateLoanComp from './CreateLoanComp';
import type { LoanComp } from '../../types/deal';
import { apiGetById } from '../../services/genesisApi/httpsMethods';
import { CircularProgress, Box } from '@mui/material';

const EditLoanCompWrapper = () => {
  const { loanCompId } = useParams();
  const [loanComp, setLoanComp] = useState<Partial<LoanComp>>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLoanComp = async () => {
      try {
        const response = await apiGetById('loan-comp', Number(loanCompId)); // API call
        if (response && response.success && response.data) {
          const data = response.data;
          setLoanComp(data[0]);
        }
      } catch (error) {
        console.error('Failed to fetch loan comp', error);
      } finally {
        setLoading(false);
      }
    };

    fetchLoanComp();
  }, [loanCompId]);

  if (loading) {
    return (
      <Box sx={{ p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return <CreateLoanComp loanComp={loanComp} isEdit={true}/>;
};

export default EditLoanCompWrapper;
